module.exports = __webpack_public_path__ + "img/1573145933.e4802ed5.jpg";